import React, { useState } from 'react';
import { CCard, CCardBody, CCardHeader, CFormInput, CCol, CRow, CButton, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CFormLabel } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData, useLocation } from 'react-router-dom';
import AxiosInstance from 'src/components/Axios';
import { cilPen, cilPlus, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { useEffect } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import Select from 'react-select';

const page = 1;
const itemsPerPage = 30;
const urlApi = '/special_machineries';
const urlRouter = '/special-machines';


// Перше завантаження
export async function LoaderSpecialMachines({ params }) {
  let res = await AxiosInstance.get(urlApi, {
    params: {
      itemsPerPage: itemsPerPage,
      page: page,
    }
  }).then((response) => {
    return response;
  });
  return res;
};


const SpecialMachines = () => {
  const { data } = useLoaderData();
  // console.log('data', data);

  const [rows, setRows] = useState(false);
  const [rowCountState, setRowCountState] = useState(0);
  // для пошуку
  const [nameFilterSearch, setNameFilterSearch] = useState('');
  const [codeFilterSearch, setCodeFilterSearch] = useState('');
  const [atpNameFilterSearch, setAtpNameFilterSearch] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  //пошук спецтехніки в селекті по типу
  const [specialMachinesFilterSearch, setSpecialMachinesFilterSearch] = useState('')
  const [types, setTypes] = useState([])

  // Заблокувати кнопку фільрації якщо не введені символи для пошуку
  const [isDisabledSearchBtn, setIsDisabledSearchBtn] = useState(true);

  console.log('specialMachinieryFilterSearch', specialMachinesFilterSearch)
  // перевірка чи є масив даних
  if (!rows) {
    setRows(data['hydra:member']); //масив
    setRowCountState(data['hydra:totalItems']); //кількість
  };

  // Фільтр
  const getRowsTable = (p = 1, clear = false) => {
    setShowLoader(true);

    let params = {
      itemsPerPage: itemsPerPage,
      page: p,
    };

    if (clear == false) {
      if (nameFilterSearch != '') {
        params['name'] = nameFilterSearch;
      };
      if (codeFilterSearch != '') {
        params['code'] = codeFilterSearch;
      };
      if (atpNameFilterSearch != '') {
        params['atp.name'] = atpNameFilterSearch;
      };
      if (specialMachinesFilterSearch != '') {
        params['type.id'] = specialMachinesFilterSearch;
      };
    };

    AxiosInstance.get(urlApi, { params: params }).then((response) => {
      setRows(response.data['hydra:member']);
      setRowCountState(response.data['hydra:totalItems']);
      setShowLoader(false);
    });
  };

  //Запит за типами техніки
  async function getMachineryTypes() {
    return AxiosInstance.get(`/special_machineries_types`
      , {
        params: {
        }
      }).then((response) => {
        console.log("get /api/special_machineries_docs_types/ response", response);
        setTypes(response.data['hydra:member'].map(item => ({
          value: item.id,
          label: item.name

        })
        ))
        return response;
      }).catch(e => console.log(e))
  }



  // зміна сторінки
  const handlePageChange = (page) => {
    getRowsTable(page + 1);
  };

  // Розблокувати кнопку, якщо хоча б одне поле містить значення
  useEffect(() => {
    if (nameFilterSearch != "" || codeFilterSearch !== "" || atpNameFilterSearch || specialMachinesFilterSearch !== ''
    ) {
      setIsDisabledSearchBtn(false);
    } else {
      setIsDisabledSearchBtn(true);
    };
  }, [nameFilterSearch, codeFilterSearch, atpNameFilterSearch, specialMachinesFilterSearch]);

  useEffect(() => {
    getMachineryTypes()
  }, [])

  // Зміна стейту пошуку "Назва"
  const handleNameFilterChange = (e) => {
    setNameFilterSearch(e.target.value);
  };

  // Зміна стейту пошуку "Код"
  const handleCodeFilterChange = (e) => {
    setCodeFilterSearch(e.target.value);
  };

  // Зміна стейту пошуку "Назва АТП"
  const handleAtpNameFilterChange = (e) => {
    setAtpNameFilterSearch(e.target.value);
  };

  // Зміна стейту пошуку "Тип спецтехніки"
  const handleSpecialMachinesFilterChange = (e) => {
    setSpecialMachinesFilterSearch(e.target.value);
  };


  // Фільтрування
  const handleFilterSearch = () => {
    getRowsTable();
  };

  // Скинути фільтр і показати весь список
  const handleFilterReset = () => {
    setNameFilterSearch('');
    setCodeFilterSearch('');
    setAtpNameFilterSearch('');
    setSpecialMachinesFilterSearch('')
    setIsDisabledSearchBtn(true);
    getRowsTable(1, true);
  };


  async function deleted(row) {
    try {
      await confirmAlert({
        title: 'Ви впевнені що хочите видалити цей пункт ?',
        message: 'Are you sure to do this.',
        buttons: [
          {
            label: 'Так',
            onClick: async () => {
              const response = await AxiosInstance.delete(`${urlApi}/${row.id}`)
              console.log('Пункт успішно видалено.', response)
              getRowsTable()
            },
          },
          {
            label: 'Ні',
            onClick: () => {
              return
            },
          },
        ],
      })
    } catch (error) {
      console.error('Помилка видалення:', error)
    };
  };

  // Дані, які навнюються в таблицю
  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'code', headerName: 'Код', width: 95 },
    {
      field: 'name',
      headerName: 'Назва',
      width: 150,
      renderCell: (params) => {
        return (
          <Link
            to={`${urlRouter}/read/${params.row.id}`}
            // style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }}
            style={{ textDecoration: 'none' }}
          >
            {params.row.name}
          </Link>
        )
      },
    },

    { field: 'brand', headerName: 'Марка', width: 170 },
    { field: 'models', headerName: 'Модель', width: 150 },
    // { field: 'description', headerName: 'Опис', width: 200 },

    // Вставка нового поля "тип"
    {
      field: 'type',
      headerName: 'Тип',
      width: 200,
      renderCell: (params) => <span>{params.row?.type?.name || ''}</span>,
    },

    {
      field: 'atp',
      headerName: 'АТП',
      width: 410,
      renderCell: (params) => {
        console.log('params', params)
        return (
          <span>
            {params.row.atp?.name ? params.row.atp.name : ""}
          </span>
        )
      },
    },

    {
      field: 'action',
      headerName: 'Action',
      width: 70,
      sortable: false,
      renderCell: (params) => {
        return (
          <Link to={`${urlRouter}/read/${params.row.id}`}>
            <CButton color="dark" variant="outline">
              <CIcon icon={cilPen} customClassName="nav-icon" height={20} />
            </CButton>
          </Link>
        )
      },
    },
    // {
    //   field: 'delete',
    //   headerName: 'Видалити',
    //   width: 80,
    //   sortable: false,
    //   renderCell: (params) => {
    //     return (
    //       <CButton
    //         color="danger"
    //         variant="outline"
    //         onClick={() => {
    //           deleted(params.row)
    //         }}
    //       >
    //         <CIcon icon={cilTrash} customClassName="nav-icon" height={20} />
    //       </CButton>
    //     )
    //   },
    // },
  ]

  // Натиснення кнопки: "Enter" - виконати пошук; "Escape" - скинути пошук
  const keyDown = (event) => {
    // Виконати пошук
    if (event.key === 'Enter' && !isDisabledSearchBtn) {
      event.preventDefault();
      handleFilterSearch(event);
    }
    // Скинути пошук
    if (event.key === 'Escape') {
      event.preventDefault();
      handleFilterReset(event);
    };
  };


  return (
    <CRow>
      <CCol xs={12}>
        <CCard className="mb-4">
          <CAccordion flush>
            <CAccordionItem>
              <CAccordionHeader>
                <strong>Фільтр</strong>
              </CAccordionHeader>
              <CAccordionBody>
                <CRow className="my-3 mx-2">
                  <CCol md={9} className="me-auto">
                    <CRow>
                      <CCol md={3} className="filter-field">
                        <CFormInput
                          placeholder="Код"
                          id="codeFilterSearch"
                          aria-label="Пошук"
                          className="me-2"
                          onChange={handleCodeFilterChange}
                          value={codeFilterSearch}
                          onKeyDown={keyDown}
                          autoComplete="off"
                        />
                      </CCol>
                      <CCol md={4} className="filter-field">
                        <CFormInput
                          placeholder="Назва"
                          id="nameFilterSearch"
                          aria-label="Пошук"
                          className="me-2"
                          onChange={handleNameFilterChange}
                          value={nameFilterSearch}
                          onKeyDown={keyDown}
                          autoComplete="off"
                        />
                      </CCol>
                      <CCol md={4} className="filter-field">
                        <CFormInput
                          placeholder="Назва АТП"
                          id="atpNameFilterSearch"
                          aria-label="Пошук"
                          className="me-2"
                          onChange={handleAtpNameFilterChange}
                          value={atpNameFilterSearch}
                          onKeyDown={keyDown}
                          autoComplete="off"
                        />
                      </CCol>
                      {/* Поле фільтра по типу */}
                      <CCol md={4} className="mt-3 filter-field">

                        <div className="col d-flex justify-content-start">
                          <Select
                            options={types}
                            value={types.find(elem => elem.value === specialMachinesFilterSearch) || ""}
                            onChange={(selectedOption) => {
                              setSpecialMachinesFilterSearch(selectedOption ? selectedOption.value : '');
                            }}
                            // className="w-25"
                            className='me-2'
                            // isDisabled={props.isDisabledChange}
                            placeholder="Виберіть тип"
                          />
                        </div>

                      </CCol>
                      {/* Поле фільтра по типу */}
                    </CRow>
                  </CCol>

                  <CCol md={3} style={{ textAlign: 'end' }}>
                    <CButton className="me-2" type="submit" color="secondary" onClick={handleFilterSearch} disabled={isDisabledSearchBtn}>Пошук</CButton>
                    <CButton type="submit" color="secondary" onClick={handleFilterReset}>X</CButton>
                  </CCol>
                </CRow>
              </CAccordionBody>
            </CAccordionItem>
          </CAccordion>

          <CCardHeader>
            <strong>Спецтехніка</strong> <small></small>
          </CCardHeader>
          <CCardBody>
            <div style={{ height: 400, width: '100%', }}>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={itemsPerPage}
                rowsPerPageOptions={[itemsPerPage]}
                pagination
                rowCount={rowCountState}
                paginationMode="server"
                onPageChange={handlePageChange}
                loading={showLoader}
              />
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default SpecialMachines;